// packages/ui-kit/src/brand/AiAnswer.tsx
// C3F v18 — reference: design/system/components/brand/AiAnswer.{jsx,prompt.md}
// An assistant answer: AE app icon inside the Spectrum ring (the border IS the
// assistant's brand signature) + body + citation pills. Sources are pills, not
// links: each one opens the cited procedure.
import { type CSSProperties, type ReactNode } from "react";
import { AppIcon } from "./AppIcon.js";

export interface AiSource {
  label: string;
  id?: string;
}

interface Props {
  children: ReactNode;
  sources?: ReadonlyArray<string | AiSource>;
  onSource?: (source: string | AiSource, index: number) => void;
  className?: string;
  style?: CSSProperties;
}

export function AiAnswer({ children, sources = [], onSource, className, style }: Props) {
  return (
    <div className={["flex items-start gap-3", className].filter(Boolean).join(" ")} style={style}>
      <span
        className="grid h-8 w-8 flex-shrink-0 place-items-center rounded-sm p-px"
        style={{ background: "var(--spectrum-8h-diag)" }}
      >
        <AppIcon size={30} radius="7px" />
      </span>
      <div className="grid min-w-0 flex-1 gap-2.5">
        <div className="text-sm leading-[1.6]">{children}</div>
        {sources.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {sources.map((s, i) => (
              <button
                key={typeof s === "string" ? s : (s.id ?? s.label)}
                type="button"
                onClick={() => onSource?.(s, i)}
                className="inline-flex items-center gap-1.5 rounded-pill border border-border-default bg-subtle px-3 py-1.5 text-left font-mono text-mono text-fg-default transition-colors duration-fast hover:bg-hover focus-visible:outline-none focus-visible:shadow-focus"
              >
                <span aria-hidden className="h-[5px] w-[5px] rounded-full bg-spectrum-2" />
                {typeof s === "string" ? s : s.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
